import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import SVG from 'react-inlinesvg'

import { getMediaURL } from '../../utils/helpers/media-url'

const Image = ({ media, className, id, keepStyle, alt }) => {
  // Fallback for empty fields
  if (media === null || media === undefined) {
    return ''
  }

  // Static images
  if (typeof media === 'string' && media.startsWith('/static')) {
    return (
      <img src={media} alt="" />
    )
  }

  // Get Image Data
  let currentURL = media.url ? media.url : ''
  const altText = media.alternativeText ? media.alternativeText : alt ? alt : ''
  let image = ''

  if (media.localFile) {
    image = getImage(media.localFile)
  } else if (media.optimizedImage) {
    image = getImage(media.optimizedImage)
  } else if (media.childImageSharp) {
    image = getImage(media)
    currentURL = media.publicURL
  } else if (media.url?.childImageSharp) {
    image = getImage(media.url)
    currentURL = media.url.publicURL
  } else {
    if (media.url && media.url.publicURL) {
      image = getMediaURL(media.url.publicURL)
      currentURL = media.url.publicURL
    } else {
      image = getMediaURL(media.publicURL ? media.publicURL : media.url)
      currentURL = media.publicURL ? media.publicURL : media.url
    }
  }
  const ext = currentURL.split('.').pop()

  // Convert SVG to inline
  if (ext === 'svg') {
    let imageUrl = getMediaURL(currentURL)
    if (media.localFile) {
      if (media.localFile !== null) {
        imageUrl = media.localFile.publicURL
      } else {
        imageUrl = currentURL
      }
    }
    if (keepStyle) {
      return (
        <SVG
          onError={error => console.log(error.message)}
          cacheRequests={true}
          src={imageUrl}
          title={altText}
          className={className}
          id={id}
        />
      )
    } else {
      return (
        <SVG
          onError={error => console.log(error.message)}
          cacheRequests={true}
          preProcessor={code =>
            code
              .replace(/fill=".*?"/g, 'fill="currentColor"')
              .replace(/fill:.*?/g, 'fill: currentColor;')
              .replace(/class=".*?"/g, '')
          }
          src={imageUrl}
          title={altText}
          className={className}
          id={id}
        />
      )
    }
  } else if (ext === 'gif') {
    const imageURL = getMediaURL(media.url)
    return (
      <img src={imageURL} />
    )
  }
  
  return (
    <>
      {(media.localFile && media.localFile !== null) || (media.childImageSharp && media.childImageSharp !== null) || (media.url?.childImageSharp && media.url?.childImageSharp !== null) ? (
        <GatsbyImage
          className={className}
          image={image}
          alt={altText}
          id={id}
          loading="lazy"
        />
      ) : (
        <img
          className={className}
          src={image}
          alt={altText}
          id={id}
          loading="lazy"
        />
      )}
    </>
  )
}

export default Image
